<template>
  <div id="home" class="pb-2">
    <AppNavbar />
    
    <div v-if="benutzer && benutzer.funktionen.sicherheit == 1">
      <HomeHeader />

      <div class="container">
        <b-row class="py-2 headSpace">
          <!-- <b-col cols="12" sm="4">
            <HilfeButton @createHilfeToast="makeToast" />
          </b-col> -->
          <b-col cols="12" sm="6">
            <HomeClock />
          </b-col>
          <b-col cols="12" sm="6">
            <ZuhauseStatus @errorMsg="makeToast"/>
          </b-col>
        </b-row>

        <hr>

        <b-row class="py-2">
          <b-col>
            <MessagesCard @messagesToast="makeToast"/>
          </b-col>
        </b-row>
      </div>
    </div>
    <b-container v-else class=" py-5 headSpace">
      <b-alert variant="danger" class="mt-4" show>Diese Seite steht dir nicht zur Verfügung</b-alert>
    </b-container>
  </div>
</template>

<script>
import AppNavbar from '@/components/Nav/AppNavbar'
import HomeHeader from '../Content/SicherheitHeader'
import HomeClock from '../Content/SicherheitClock'
import ZuhauseStatus from '../Content/ZuhauseStatus'
// import HilfeButton from '../Content/HilfeButton'
import MessagesCard from '@/components/Kommunikation/Content/MessagesCard'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Home',
  components: {
    AppNavbar,
    HomeHeader,
    HomeClock,
    ZuhauseStatus,
    MessagesCard,
    // HilfeButton
  },
  computed: mapGetters(['benutzer', 'kontakte', 'fotoalben']),
  methods: {
    ...mapActions(['abmelden', 'getBenutzerKontakte', 'fetchFotoalben', 'fetchZuhauseStatus']),
    makeToast (toast) {
      this.$bvToast.toast(toast.msg, {
        title: toast.title,
        toaster: 'b-toaster-bottom-full',
        variant: toast.variant,
        autoHideDelay: 7000,
        appendToast: true,
        solid: true
      })
    }
  },
  mounted () {
    if (this.kontakte.length === 0) {
      this.getBenutzerKontakte()
    }

    this.fetchZuhauseStatus()
  }
}
</script>

<style scoped>
  .headSpace {
    margin-top: 1em;
  }

  @media screen and (max-width: 576px) {
    .headSpace {
      margin-top: 0em;
      padding-top: 2rem !important;
    }
  }

  @media screen and (min-width: 577px) and (max-width: 992px) {
    .headSpace {
      margin-top: 0em;
      padding-top: 1rem !important;
    }
  }
</style>